var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "rounded-lg border relative"
  }, [_c('div', {
    staticClass: "bg-gray-100 px-2.5 py-2.5 uppercase"
  }, [_vm._v("Coupon Code")]), _c('div', {
    staticClass: "px-2.5 py-2.5 border-b"
  }, [_c('button', {
    staticClass: "border-custom px-2.5 py-2.5 text-blue-500 w-1/3 rounded-lg",
    on: {
      "click": _vm.openNewModal
    }
  }, [_vm._v("+ Add new")])]), _c('t-modal', {
    ref: "addCouponCodeModal"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-left mb-3"
  }, [_c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 block"
  }, [_vm._v("Coupon Prefix")]), _c('input', {
    staticClass: "rounded-lg mb-1 w-full uppercase",
    class: {
      'bg-gray-300 pointer-events-none ': _vm.isPrefixSet,
      'bg-gray-300 pointer-events-none': _vm.mode === 'edit'
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isPrefixSet,
      "placeholder": "e.g.: MDRSDP",
      "disabled": _vm.mode === 'edit'
    },
    domProps: {
      "value": _vm.computedCouponPrefix
    },
    on: {
      "input": function ($event) {
        return _vm.updatePrefix($event.target.value);
      }
    }
  }), _c('p', {
    staticClass: "text-xs text-gray-500"
  }, [_vm._v("Max 6 characters and must be unique.")]), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold mt-2 block"
  }, [_vm._v("Number of Coupons")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.numberCoupon,
      expression: "numberCoupon"
    }],
    staticClass: "rounded-lg mb-4 w-full",
    attrs: {
      "type": "number",
      "placeholder": "e.g.: 50"
    },
    domProps: {
      "value": _vm.numberCoupon
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.numberCoupon = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-blue-700 py-2.5 px-2.5 w-full text-white rounded-lg",
    on: {
      "click": _vm.saveCode
    }
  }, [_vm._v(" Save ")])])]), !_vm.isEditMode ? _c('div', [_vm.form.couponCodes.length ? _c('div', {
    staticClass: "mt-4 px-2.5 py-2.5"
  }, [_c('ul', _vm._l(_vm.form.couponCodes, function (coupon, index) {
    return _c('li', {
      key: index,
      staticClass: "text-gray-800 text-sm border w-1/3 px-2.5 py-2.5 mb-2.5 rounded-lg bg-gray-100 relative"
    }, [_vm._v(" " + _vm._s(coupon) + " ")]);
  }), 0)]) : _c('div', [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex h-96"
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])]) : _vm._e(), _vm.isEditMode ? _c('div', [_vm.form.couponCodes.length ? _c('div', {
    staticClass: "mt-4 px-2.5 py-2.5"
  }, [_c('ul', _vm._l(_vm.form.couponCodes, function (coupon, index) {
    return _c('li', {
      key: index,
      staticClass: "text-gray-800 text-sm border w-1/3 px-2.5 py-2.5 mb-2.5 rounded-lg bg-gray-100 relative uppercase"
    }, [_vm._v(" " + _vm._s(coupon.code) + " ")]);
  }), 0)]) : _c('div', [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex h-96"
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }